<script>
  export let user
</script>

{#if user.avatar}
  <img
    src={user.avatar.thumbnail}
    width="30"
    height="30"
    class="rounded-circle"
    alt="Avatar of {user.display_name}"
  />
{:else}
  <img
    src="https://avatars.dicebear.com/api/adventurer/{user.id}.svg?size=30&background=%23cccccc"
    width="30"
    height="30"
    class="rounded-circle"
    alt="Placeholder Avatar for {user.display_name}"
  />
{/if}

{user.display_name}
